<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
		<template slot="bodyForm">
			<CLoader :pConfigLoad="ConfigLoad">
        		<template slot="BodyFormLoad">
					<div class="container-fluid">
                        <form id="FormEmpresa" role="form" method="post" autocomplete="off" onSubmit="return false">
                            <legend class="col-form-label">Datos Generales</legend>

                            <div class="row mt-4">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-2">
                                    <div class="avatar-upload">
                                        <div class="avatar-edit">
                                            <input id="file"  @change="$uploadImagePreview($event,ValidElement,Array('Img','imagePreview'))"  ref="file"  type="file" name="myfile"  accept=".png, .jpg, .jpeg">
                                            <label for="file"></label>
                                        </div>

                                        <div class="avatar-preview">
                                            <div id="imagePreview" :style="'background-image: url('+RutaFile+Empresa.Imagen+');'" :src="RutaFile+Empresa.Imagen">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-10">
                                    <div class="form-group row">
                                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <label for="NombreComercial">Nombre Comercial</label>
                                            <input  class="form-control" id="NombreComercial" v-model="Empresa.NombreComercial" type="text" placeholder="Ingrese Nombre Comercial"/>
                                            <CValidation v-if="this.errorvalidacion.NombreComercial" :Mensaje="'*' + errorvalidacion.NombreComercial[0]" />
                                        </div>

                                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <label for="RazonSocial">Razón Social</label>
                                            <input class="form-control" id="RazonSocial" v-model="Empresa.RazonSocial" type="text" placeholder="Ingrese Razón Social"/>
                                            <CValidation v-if="this.errorvalidacion.RazonSocial" :Mensaje="'*' + errorvalidacion.RazonSocial[0]" />
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                            <label for="Rfc">RFC</label>
                                            <input class="form-control" id="Rfc" v-model="Empresa.Rfc" type="text" placeholder="Ingrese RFC"/>
                                            <CValidation v-if="this.errorvalidacion.Rfc" :Mensaje="'*' + errorvalidacion.Rfc[0]"/>
                                        </div>

                                        <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                                            <label for="RegimenFiscal">Régimen Fiscal</label>
                                            <select class="form-control form-select" v-model="Empresa.RegimenFiscal" id="RegimenFiscal">
                                                <option value="">Seleccione una opción</option>
                                                <option v-for="(item,index) in ListaRegimenes" :key="index" :value="item.Clave+'~'+item.Nombre">
                                                    {{ item.Clave+' - '+item.Nombre }}
                                                </option>
                                            </select>
                                            <CValidation v-if="this.errorvalidacion.RegimenFiscal" :Mensaje="'*'+errorvalidacion.RegimenFiscal[0]"/>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                            <label for="Telefono">Telefono</label>
                                            <input  type="text" v-model="Empresa.Telefono" class="form-control" id="Telefono" maxlength="10" @input="$onlyNums($event,Empresa,'Telefono')" placeholder="Ingrese Teléfono"/>
                                            <CValidation v-if="this.errorvalidacion.Telefono" :Mensaje="'*' + errorvalidacion.Telefono[0]"/>
                                        </div>

                                        <div class="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6">
                                            <label for="Correo">Correo</label>
                                            <input type="text" v-model="Empresa.Correo" class="form-control" id="Correo"    placeholder="Ingrese Correo"/>
                                            <CValidation v-if="this.errorvalidacion.Correo" :Mensaje="'*' + errorvalidacion.Telefono[0]"/>
                                        </div>

                                        <div class="col-12 col-sm-12 col-md-4 col-lg-2 col-xl-2">
                                            <label for="Cp">Código Postal</label>
                                            <input class="form-control" id="Cp" v-model="Empresa.CodigoPostal" type="text" @input="$onlyNums($event,Empresa,'CodigoPostal')" placeholder="Código Postal" maxlength="10"/>
                                            <CValidation v-if="this.errorvalidacion.CodigoPostal" :Mensaje="'*' + errorvalidacion.CodigoPostal[0]"/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">

                                    <div class="form-group row">
                                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                            <label for="Calle">Calle</label>
                                            <input class="form-control" id="Calle" v-model="Empresa.Calle" type="text" placeholder="Ingrese Calle"/>
                                            <CValidation v-if="this.errorvalidacion.Calle" :Mensaje="'*' + errorvalidacion.Calle[0]"/>
                                        </div>

                                        <div class="col-12 col-sm-12 col-md-4 col-lg-2 col-xl-2">
                                            <label for="NoExt">Número Exterior</label>
                                            <input class="form-control" id="NoExt" v-model="Empresa.NoExt" type="text" placeholder="Número Exterior"/>
                                            <CValidation v-if="this.errorvalidacion.NoExt" :Mensaje="'*' + errorvalidacion.NoExt[0]"/>
                                        </div>

                                        <div class="col-12 col-sm-12 col-md-4 col-lg-2 col-xl-2">
                                            <label for="NoInt">Número Interior</label>
                                            <input class="form-control" id="NoInt" v-model="Empresa.NoInt" type="text" placeholder="Número Interior"/>
                                            <CValidation v-if="this.errorvalidacion.NoInt" :Mensaje="'*' + errorvalidacion.NoInt[0]"/>
                                        </div>

                                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                            <label for="Cruzamiento1">Cruzamiento 1</label>
                                            <input class="form-control" id="Cruzamiento1" v-model="Empresa.Cruzamiento1" type="text" placeholder="Ingrese Cruzamiento 1" maxlength="10"/>
                                            <CValidation v-if="this.errorvalidacion.Cruzamiento1" :Mensaje="'*' + errorvalidacion.Cruzamiento1[0]"/>
                                        </div>

                                        
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                            <label for="Cruzamiento2">Cruzamiento 2</label>
                                            <input class="form-control" id="Cruzamiento2" v-model="Empresa.Cruzamiento2" type="text" placeholder="Ingrese Cruzamiento2" maxlength="10"/>
                                            <CValidation v-if="this.errorvalidacion.Cruzamiento2" :Mensaje="'*' + errorvalidacion.Cruzamiento2[0]"/>
                                        </div>

                                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                            <label for="Pais">País</label>
                                            <select v-model="Empresa.IdPais" @change="GetListEstados();" class="form-control form-select" id="Pais">
                                                <option value="0">Seleccione una opción</option>
                                                <option v-for="(item,index) in ListaPaises" :key="index" :value="item.IdPais">{{item.Clave+' - '+item.Nombre}}</option>
                                            </select>
                                            <CValidation v-if="this.errorvalidacion.IdPais" :Mensaje="'*'+errorvalidacion.IdPais[0]"/>  
                                        </div>

                                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                            <label for="Estado">Estado</label>
                                            <select v-model="Empresa.IdEstado" id="Estado" class="form-control form-select" @change="GetListMunicipios();GetListLocalidad();">
                                                <option value="0">Seleccione una opción</option>
                                                <option v-for="(item, index) in ListaEstados" :key="index" :value="item.IdEstado">
                                                    {{ item.Clave+' - '+item.Nombre }}
                                                </option>
                                            </select>
                                            <CValidation v-if="this.errorvalidacion.IdEstado" :Mensaje="'*' + errorvalidacion.IdEstado[0]"/>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                            <label for="Municipio">Municipio</label>
                                            <select v-model="Empresa.ClaveMunicipio" @change="GetListColonias();" id="Municipio" class="form-control form-select">
                                                <option value="">Seleccione una opción</option>
                                                <option v-for="(item, index) in ListaMunicipios" :key="index" :value="item.Clave">
                                                    {{ item.Clave+' - '+item.Nombre }}
                                                </option>
                                            </select>
                                            <CValidation v-if="this.errorvalidacion.IdMunicipio" :Mensaje="'*' + errorvalidacion.IdMunicipio[0]"/>
                                        </div>

                                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                            <label for="Colonia">Colonia</label>
                                            <select v-model="Empresa.IdColonia" id="Colonia" class="form-control form-select">
                                                <option value="0">Seleccione una opción</option>
                                                <option v-for="(item, index) in ListaColonias" :key="index" :value="item.IdColonia">
                                                    {{ item.Clave+' - '+item.Nombre }}
                                                </option>
                                            </select>
                                            <CValidation v-if="this.errorvalidacion.IdColonia" :Mensaje="'*' + errorvalidacion.IdColonia[0]"/>
                                        </div>

                                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                            <label for="Localidad">Localidad</label>
                                            <select v-model="Empresa.IdLocalidad" class="form-control form-select" id="Localidad">
                                                <option value="0">Seleccione una opción</option>
                                                <option v-for="(item, index) in ListaLocalidades" :key="index" :value="item.IdLocalidad">{{item.Clave+' - '+item.Nombre}}</option>
                                            </select>
                                            <CValidation v-if="this.errorvalidacion.IdLocalidad" :Mensaje="'*'+errorvalidacion.IdLocalidad[0]"/>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <label for="Referencias">Referencias</label>
                                            <textarea class="form-control" id="Referencias" v-model="Empresa.Referencias" placeholder="Ingrese Referencias" rows="2"/>
                                            <CValidation v-if="this.errorvalidacion.Referencias" :Mensaje="'*' + errorvalidacion.Referencias[0]"/>
                                        </div>                                        
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-2">
                                <div class="col-12">
                                    <CBtnSave v-if="segurity.BtnSave" :poBtnSave="oBtnSave" />
                                </div>
                            </div>
                        </form>
                    </div>
                </template>
            </CLoader>
        </template>
        </CList>
        <br>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList2" :pFiltro="Filtro" :segurity="segurity">
			<template slot="header">
				<th :class="StyleTh+' text-center'">#</th>
				<th :class="StyleTh">Nombre</th>
				<th :class="StyleTh">Teléfono</th>
                <th :class="StyleTh">Clave Sucursal</th>
				<th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista, index) in ListaArrayRows" :key="index">
					<td class="text-center"><p :class="StyleTd">{{ $getNumItem(index) }}</p></td>
					<td><p :class="StyleTd">{{ lista.Nombre }}</p></td>
					<td><p :class="StyleTd">{{ lista.Telefono }}</p></td>
                    <td><p :class="StyleTd">{{ lista.ClaveSucursal }}</p></td>
					<td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="false" :pIsModal="true" :pId="lista.IdSucursal" :pEmitSeccion="ConfigList2.EmitSeccion" :segurity="segurity">
							<template slot="btnaccion"> </template>
						</CBtnAccion>
					</td>
				</tr>
				<CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="5" ></CSinRegistros>
			</template>
		</CList>

		<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave2">
			<template slot="Form">
				<FormSucursal :poBtnSave="oBtnSave2"></FormSucursal>
			</template>
		</CModal>
    </div>
</template>

<script>

import FormSucursal from '@/views/modulos/empresa/miempresa/FormSucursal.vue';
import Configs      from '@/helpers/VarConfig.js';
const  emmitEmpresa =    'seccionEmpresa';
const  EmitEjecuta  =    'seccionSucursal';

export default {
    name:  'FormMiEmpresa',
    props: ['sFiltros','pOrigen'],
    components:{
        FormSucursal
    },
    data() {
        return {
            ConfigList: {
                Title: "Mi Empresa",
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: "Form",
                ShowLoader: false,
                EmitSeccion: emmitEmpresa,
                TitleFirst: '',
                ShowFooter: false,
            },
            ConfigLoad: {
                ShowLoader: false,
                ClassLoad: false,
            },
            oBtnSave: {
                Toast: 0,
                IsModal: false,
                ShowBtnSave: true,
                ShowBtnCancel: false,
                DisableBtn: false,
                EmitSeccion: emmitEmpresa,
            },
            ConfigList2: {
                Title: "Listado Sucursales",
                IsModal: true,
                ShowLoader: true,
                BtnReturnShow: false,
                EmitSeccion: EmitEjecuta,
            },
            Filtro: {
                Nombre: "",
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: "Buscar..",
            },
            ConfigModal: {
                ModalTitle: "Formulario Sucursal",
                ModalNameId: "ModalForm",
                EmitSeccion: EmitEjecuta,
                ModalSize: "lg",
            },
            oBtnSave2: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            Empresa:{
                IdEmpresa: 0,
				NombreComercial: '',
				RazonSocial: '',
				Rfc: '',
				RegimenFiscal: '',
				Calle: '',
				NoInt: '',
				NoExt: '',
				Cruzamiento1: '',
				Cruzamiento2: '',
				CodigoPostal: '',
				Telefono: '',
				Correo: '',
				Referencias: '',
				IdPais: 0,
				ClavePais: '',
				Pais: '',
				IdEstado: 0,
				ClaveEstado: '',
				Estado: '',
				IdMunicipio: 0,
				ClaveMunicipio: '',
				Municipio: '',
				IdColonia: 0,
				ClaveColonia: '',
				Colonia: '',
				IdLocalidad: 0,
				ClaveLocalidad: '',
				Localidad: '',
				EstatusEmpresa: 0,
            },
            ValidElement: Configs.validImage2m,
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,    
            emmit: emmitEmpresa,
            ListaArrayRows:  [],
            errorvalidacion: [],
            segurity:        {},
            obj:             {},
            ListaPaises: [],
            ListaEstados: [],
            ListaMunicipios: [],
            ListaColonias: [],
            ListaLocalidades: [],
            ListaRegimenes:[],
            RutaFile: '',
            counterField: 1,
        }
    },
    methods:{
        UpdateEmpresa()
        {
            let formData = new FormData();
            formData.set('IdEmpresa', this.Empresa.IdEmpresa);
            formData.set('NombreComercial', this.Empresa.NombreComercial);
            formData.set('RazonSocial', this.Empresa.RazonSocial);
            formData.set('RegimenFiscal', this.Empresa.RegimenFiscal);
            formData.set('Rfc', this.Empresa.Rfc);
            formData.set('Calle', this.Empresa.Calle);
            formData.set('NoInt', this.Empresa.NoInt);
            formData.set('NoExt', this.Empresa.NoExt);
            formData.set('Cruzamiento1', this.Empresa.Cruzamiento1);
            formData.set('Cruzamiento2', this.Empresa.Cruzamiento2);
            formData.set('CodigoPostal', this.Empresa.CodigoPostal);
            formData.set('Telefono', this.Empresa.Telefono);
            formData.set('Correo', this.Empresa.Correo);
            formData.set('Referencias', this.Empresa.Referencias);

            let Pais = this.GetDataTipo(1,this.Empresa.IdPais);
            let Estado = this.GetDataTipo(2,this.Empresa.IdEstado);
            let Municipio = this.GetDataTipo(3,this.Empresa.ClaveMunicipio);
            let Colonia = this.GetDataTipo(4,this.Empresa.IdColonia);
            let Localidad = this.GetDataTipo(5,this.Empresa.IdLocalidad);


            formData.set('IdPais', Pais.Id);
            formData.set('ClavePais', Pais.Clave);
            formData.set('Pais', Pais.Nombre);
            formData.set('IdEstado', Estado.Id);
            formData.set('ClaveEstado', Estado.Clave);
            formData.set('Estado', Estado.Nombre);
            formData.set('IdMunicipio', Municipio.Id);
            formData.set('ClaveMunicipio', Municipio.Clave);
            formData.set('Municipio', Municipio.Nombre);
            formData.set('IdColonia', Colonia.Id);
            formData.set('ClaveColonia', Colonia.Clave);
            formData.set('Colonia', Colonia.Nombre);
            formData.set('IdLocalidad', Localidad.Id);
            formData.set('ClaveLocalidad', Localidad.Clave);
            formData.set('Localidad', Localidad.Nombre);
            formData.set('EstatusEmpresa', this.Empresa.EstatusEmpresa);
            formData.set('ImagenOld', this.Empresa.Imagen);

            let picture = this.$refs.file.files[0];
            formData.append('Imagen',picture);

            this.errorvalidacion     = [];
            this.oBtnSave.Toast      = 0;
            this.oBtnSave.DisableBtn = true;

            this.$http.post("empresasup",formData,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((res) => {
                this.EjecutaConExito(res);
            })
            .catch((err) => {
                this.EjecutaConError(err);
            });
        },
        EjecutaConExito(res)
        {
            this.oBtnSave.DisableBtn = false;
            this.oBtnSave.Toast      = 1;
            this.bus.$emit("CloseModal_" + this.Emit);
            this.bus.$emit("List_" + this.Emit);
        },
        EjecutaConError(err)
        {
            this.oBtnSave.DisableBtn = false;

            if (err.response.data.errors) {
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast  = 2;
            } else {
                this.$toast.error(err.response.data.message);
            }

        },
        async RecuperaEmpresa()
        {
            let usr = JSON.parse(sessionStorage.getItem('user'));

            await this.$http.get('empresas/'+usr.IdEmpresa).then(res => {
                this.Empresa  = res.data.data;
                this.RutaFile = res.data.rutaFile;
                this.segurity = res.data.segurity;
                let IdEstado = this.Empresa.IdEstado;
                let ClaveMunicipio = this.Empresa.ClaveMunicipio;
                let IdColonia = this.Empresa.IdColonia;
                let IdLocalidad = this.Empresa.IdLocalidad;

                this.GetListEstados();
                this.Empresa.IdEstado = IdEstado;
                this.GetListMunicipios();
                this.Empresa.ClaveMunicipio = ClaveMunicipio;
                this.GetListColonias();
                this.Empresa.IdColonia = IdColonia;
                this.GetListLocalidad();
                this.Empresa.IdLocalidad = IdLocalidad;

            }).catch(err =>{
                this.limpiar();
            })
            .finally(() => {
                //this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar(){
            this.Empresa = {
                IdEmpresa: 0,
				NombreComercial: '',
				RazonSocial: '',
				Rfc: '',
				RegimenFiscal: '',
				Calle: '',
				NoInt: '',
				NoExt: '',
				Cruzamiento1: '',
				Cruzamiento2: '',
				CodigoPostal: '',
				Telefono: '',
				Correo: '',
				Referencias: '',
				IdPais: 0,
				ClavePais: '',
				Pais: '',
				IdEstado: 0,
				ClaveEstado: '',
				Estado: '',
				IdMunicipio: 0,
				ClaveMunicipio: '',
				Municipio: '',
				IdColonia: 0,
				ClaveColonia: '',
				Colonia: '',
				IdLocalidad: 0,
				ClaveLocalidad: '',
				Localidad: '',
				EstatusEmpresa: 0,
            };
        },
        Regresar() {
            this.$router.push({name: 'panelSubMenus'});
        },
        async Lista()
        {
            this.ConfigList2.ShowLoader = true;

            await this.$http
            .get("sucursales", {
                params: {
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada:     this.Filtro.Entrada,
                    Pag:         this.Filtro.Pagina,
                },
            })
            .then((res) => {
                this.ListaArrayRows   = res.data.data.data;
                this.Filtro.Pagina    = res.data.data.current_page;
                this.Filtro.TotalItem = res.data.data.total;
                this.segurity           = res.data.segurity;
                this.$setStartItem();
            })
            .finally(() => {
                this.ConfigList2.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar)
            .then((result) => {
                if (result.value) {
                    this.$http.delete("sucursales/" + Id)
                    .then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    })
                    .catch((err) => {
                        this.$toast.error(err.response.data.message);
                    });
                }
            });
        },
        GetListRegimenFiscal()
        {
			this.$http.get('regimenesfiscales',{
				params:{
					Simple:1
				}
			}).then((res)=>{
				this.ListaRegimenes = res.data.data;
			})
		},
        GetListPaises()
		{ 
            this.$http.get(
                "cpPaises",{
                params:{
                    simple: 1
                }
            }).then((res) => {
                this.ListaPaises = res.data.data;
            });
        },
        GetListEstados()
		{
            this.Empresa.IdEstado = 0;
			this.ListaEstados = [];

            this.Empresa.ClaveMunicipio = '';
			this.ListaMunicipios = [];

			this.Empresa.IdColonia = 0;
			this.ListaColonias = [];

            if(this.Empresa.IdPais>0)
			{
                this.$http.get(
                    "cpEstados",{
                        params:{
                            simple: 1,
                            IdPais: this.Empresa.IdPais
                        }
                    }
                ).then((res) => {
                    this.ListaEstados = res.data.data;
                });
            }
		},
		GetListMunicipios()
		{
			this.Empresa.ClaveMunicipio = '';
			this.ListaMunicipios = [];

			this.Empresa.IdColonia = 0;
			this.ListaColonias = [];

			if(this.Empresa.IdEstado>0)
			{
				this.$http.get(
					"cpMunicipios",
					{
						params:{
                            simple: 1,
                            IdEstado: this.Empresa.IdEstado
                        }
					}
				).then((res) => {
					this.ListaMunicipios = res.data.data;
				});
			}
		},
		GetListColonias()
		{
			this.Empresa.IdColonia = 0;
			this.ListaColonias = [];

			if(this.Empresa.ClaveMunicipio!='')
			{
				this.$http.get(
					"cpColonias",
					{
						params:{
                            simple: 1,
							IdMunicipio: this.Empresa.ClaveMunicipio,
						}
					}
				).then((res) => {
					this.ListaColonias = res.data.data;
				});
			}
		},
		GetListLocalidad()
		{
			this.Empresa.IdLocalidad = 0;
			this.ListaLocalidades = [];

			if(this.Empresa.IdEstado>0)
			{
				this.$http.get(
					"cpLocalidades",
					{
						params:{
                            simple: 1,
							IdEstado: this.Empresa.IdEstado,
						}
					}
				).then((res) => {
					this.ListaLocalidades = res.data.data;
				}).finally(() => {
                    this.ConfigLoad.ShowLoader = false;
                });
			}
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
		},
        GetDataTipo(Tipo,Id)
        {
            let Arreglo = [];
            let ValorBusqueda = '';
            let IdValor = 0;
            let Clave = '';
            let Nombre = '';
            let Permitir = 0;

            if(Tipo == 3 && Id !='' && Id != null){
                Permitir = 1;
            }
            else if(Tipo != 3 && Id>0){
                Permitir = 1;
            }

            if(Permitir == 1)
            {
                switch(Tipo)
                {
                    case 1:
                        Arreglo = this.ListaPaises;
                        ValorBusqueda = 'IdPais';
                    break;
                    case 2:
                        Arreglo = this.ListaEstados;
                        ValorBusqueda = 'IdEstado';
                    break;
                    case 3:
                        Arreglo = this.ListaMunicipios;
                        ValorBusqueda = 'Clave';
                    break;
                    case 4:
                        Arreglo = this.ListaColonias;
                        ValorBusqueda = 'IdColonia';
                    break;
                    case 5:
                        Arreglo = this.ListaLocalidades;
                        ValorBusqueda = 'IdLocalidad';
                    break;
                }

                let respuesta = Arreglo.filter(function(element){
                    if(element[ValorBusqueda] == Id){
                        return element;
                    }
                    else{
                        return '';
                    }
                });

                if(respuesta[0])
                {
                    IdValor = (Tipo == 3) ? respuesta[0].IdMunicipio : respuesta[0][ValorBusqueda];
                    Clave = respuesta[0].Clave;
                    Nombre = respuesta[0].Nombre;
                }
            }

            let obj = {
                Id: IdValor,
                Clave: Clave,
                Nombre: Nombre,
            };

            return obj;
        }
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
            this.ConfigList2.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
            this.ConfigList2.ShowTitleFirst = false;
        }

        this.bus.$off("Save_"+this.emmit);
        this.bus.$off("List_"+EmitEjecuta);
        this.bus.$off("Delete_"+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.ConfigLoad.ShowLoader = true;
        this.oBtnSave.DisableBtn   = false;
        this.GetListRegimenFiscal();
        this.GetListPaises();
        this.RecuperaEmpresa();
        this.Lista();

        this.bus.$on("Save_"+this.emmit, () => {
            this.UpdateEmpresa();
        });

        this.bus.$on("Delete_"+EmitEjecuta, (Id) => {
            this.Eliminar(Id);
        });

        this.bus.$on("List_"+EmitEjecuta, () => {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>